export default __webpack_public_path__ + "static/media/icon-transparency.68483e71.svg";